<div class="container-fluid">
  <div class="mx-2 mt-2"><h2><b>Frequently Asked Questions</b></h2></div>

  <!-- <div class="py-2 mt-2 d-flex"  *ngFor="let faqs of faqList"> -->
  <div class="py-2 mt-2 d-flex">
    <div class="container-fluid">
      <mat-accordion>
        <mat-expansion-panel (opened)="panelOpenState = true" (closed)="panelOpenState = false">
          <mat-expansion-panel-header>
            <mat-panel-title class="d-flex">
              <!-- <span><b>{{faqs?.question}}</b></span> -->
              <span>When does the admission process start?</span>
            </mat-panel-title>
          </mat-expansion-panel-header>
          <!-- <span [innerHTML]="faqs?.answer"></span> -->
          <span>Admission forms are available from Nov.</span>
        </mat-expansion-panel>

        <mat-expansion-panel (opened)="panelOpenState = true" (closed)="panelOpenState = false">
          <mat-expansion-panel-header>
            <mat-panel-title class="d-flex">
              <span>What documents are required for admission?</span>
            </mat-panel-title>
          </mat-expansion-panel-header>
          <span>Birth certificate, transfer certificate (if applicable), and recent passport-size photographs are required.</span>
        </mat-expansion-panel>

        <mat-expansion-panel (opened)="panelOpenState = true" (closed)="panelOpenState = false">
          <mat-expansion-panel-header>
            <mat-panel-title class="d-flex">
              <span>Is there a transport facility available?</span>
            </mat-panel-title>
          </mat-expansion-panel-header>
          <span>Yes, we provide transport facilities covering major routes in the city.</span>
        </mat-expansion-panel>

        <mat-expansion-panel (opened)="panelOpenState = true" (closed)="panelOpenState = false">
          <mat-expansion-panel-header>
            <mat-panel-title class="d-flex">
              <span>Are there extracurricular activities offered?</span>
            </mat-panel-title>
          </mat-expansion-panel-header>
          <span>Yes, we offer a variety of activities including sports, music, drama, and art.</span>
        </mat-expansion-panel>

        <mat-expansion-panel (opened)="panelOpenState = true" (closed)="panelOpenState = false">
          <mat-expansion-panel-header>
            <mat-panel-title class="d-flex">
              <span>What is the teacher-student ratio?</span>
            </mat-panel-title>
          </mat-expansion-panel-header>
          <span>We maintain an ideal teacher-student ratio of 1:20 for personalized attention.</span>
        </mat-expansion-panel>

      </mat-accordion>
    </div>
  </div>
</div>
